module.exports = __webpack_public_path__ + "img/excel.62931399.png";